import webStorageKeyEnum from '@/enums/web-storage-key.enum'
import { ACTION_PREFIX_BANK_ACCOUNT_LIST, ACTION_PREFIX_LISTS } from '@/redux/ducks/constants'

class WebStorageService {

  constructor() {
    this._storageType = 'localStorage'
    this._fallbackStorage = {}

    if (!navigator.cookieEnabled || !window.localStorage) {
      this._storageType = 'webStorageFallback'
      this._createFallbackStorage()
    }
  };

  setItem(key, value) {
    window[this._storageType].setItem(key, typeof value === 'string' ? value : JSON.stringify(value))
  };

  getItem(key) {
    let value = null

    try {
      value = JSON.parse(window[this._storageType].getItem(key))
    } catch (err) {
      value = window[this._storageType].getItem(key)
    }

    return value
  }

  removeItem(key) {
    window[this._storageType].removeItem(key)
  }

  clear() {
    Object.values(webStorageKeyEnum).forEach(storageKey => {
      this.removeItem(storageKey)
    })
    Object.keys(window[this._storageType]).forEach(storageKey => {
      if (storageKey.startsWith(ACTION_PREFIX_LISTS) || storageKey.startsWith(ACTION_PREFIX_BANK_ACCOUNT_LIST)) {
        this.removeItem(storageKey)
      }
    })
  }

  _createFallbackStorage() {
    const self = this

    window[this._storageType] = {
      clear: () => {
        self._fallbackStorage = {}
      },

      getItem: (key) => {
        return self._fallbackStorage[key]
      },

      removeItem: (key) => {
        delete self._fallbackStorage[key]
      },

      setItem: (key, value) => {
        self._fallbackStorage[key] = value
      },
    }
  }
}

export default new WebStorageService()
